import * as React from 'react';

import { ErrorMessageWrapper, ErrorMessageWrapperProps } from '.';
import { errorMessageWrapperDriverFactory } from './ErrorMessageWrapper.driver';
import { createRendererWithUniDriver } from '../../../test/utils';

describe('ErrorMessageWrapper', () => {
  const createDriver = createRendererWithUniDriver(
    errorMessageWrapperDriverFactory,
  );
  const sampleMessage = 'This is an error message!';
  const sampleMessageId = 'error-message-element';

  const bootstrap = (props: ErrorMessageWrapperProps) => {
    return createDriver(<ErrorMessageWrapper {...props} />);
  };

  it('renders the message when `visible` is true', async () => {
    const { driver } = bootstrap({
      message: sampleMessage,
      messageId: sampleMessageId,
      visible: true,
    });

    expect(await driver.getErrorMessage()).toBe(sampleMessage);
    expect(await driver.getErrorMessageId()).toBe(sampleMessageId);
  });

  it('does not render the message when `visible` is false', async () => {
    const { driver } = bootstrap({
      message: sampleMessage,
      messageId: sampleMessageId,
      visible: false,
    });

    expect(await driver.isErrorVisible()).toBe(false);
  });

  it('should set lang to root', async () => {
    const lang = 'he';
    const { driver } = bootstrap({
      message: sampleMessage,
      messageId: sampleMessageId,
      lang,
    });

    expect(await driver.getLang()).toBe(lang);
  });
});
